module.exports = __webpack_public_path__ + "static/media/expertise.c35bb964.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/expertise.jpg
// module id = 1020
// module chunks = 0